import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// --- Suppress browser-extension originated errors from CRA overlay ---
// React DevTools (and some other extensions) throw on React 19 with a
// semver comparison bug; those errors originate from chrome-extension://
// URLs and are not from our app. We stop them before CRA's overlay picks
// them up.
if (typeof window !== "undefined") {
    const isExtensionOrigin = (source) =>
        typeof source === "string" &&
        (source.startsWith("chrome-extension://") ||
            source.startsWith("moz-extension://") ||
            source.startsWith("safari-web-extension://"));

    window.addEventListener(
        "error",
        (event) => {
            const src = event?.filename || event?.error?.stack || "";
            if (isExtensionOrigin(event?.filename) || (typeof src === "string" && src.indexOf("chrome-extension://") !== -1)) {
                event.stopImmediatePropagation();
                event.preventDefault();
            }
        },
        true
    );

    window.addEventListener(
        "unhandledrejection",
        (event) => {
            const stack = event?.reason?.stack || "";
            if (typeof stack === "string" && stack.indexOf("chrome-extension://") !== -1) {
                event.stopImmediatePropagation();
                event.preventDefault();
            }
        },
        true
    );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
